export const ROLE = {
    "GUEST": "guest",
    "ADVISOR": "advisor",
    "ADMINTRATOR": "admintrator"
}